import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4c2abb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon search" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "annotation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderView = _resolveComponent("LoaderView")!
  const _component_MaskView = _resolveComponent("MaskView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "html" }, [
      (!_ctx.searchStore.searchFinished)
        ? (_openBlock(), _createBlock(_component_MaskView, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_LoaderView)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "searchTerm",
          placeholder: "Type or paste your SMILES here",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.smiles) = $event))
        }, null, 512), [
          [_vModelText, _ctx.smiles]
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "searchButton",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, [
          _createTextVNode(" Example: "),
          _createElementVNode("span", {
            id: "example",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.runExample && _ctx.runExample(...args)))
          }, _toDisplayString(_ctx.exampleSmiles), 1)
        ]),
        _createElementVNode("span", {
          id: "advanced-search",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openEditor && _ctx.openEditor(...args)), ["prevent"]))
        }, "Draw Structure")
      ])
    ])
  ], 64))
}